namespace $.$$ {
	
	$mol_style_define( $hyoo_budget_intro, {
		
		flex: {
			basis: `50rem`,
		},
		
	} )
	
}
